import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Waffen from "@/pages/Waffen";
import Munition from "@/pages/Munition";
import Zubehoer from "@/pages/Zubehoer";
import Fachhandel from "@/pages/Fachhandel";
import Kontakt from "@/pages/Kontakt";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/waffen" element={<Waffen />} />
            <Route path="/munition" element={<Munition />} />
            <Route path="/zubehoer" element={<Zubehoer />} />
            <Route path="/fachhandel" element={<Fachhandel />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
